import { Outlet, useParams, Link } from 'react-router-dom'
import { Compass } from 'lucide-react'
import { Sidebar } from '../shared/components/Sidebar'
import { TabBar } from '../shared/components/TabBar'
import { OfflineWarning } from '../shared/components/OfflineWarning'
import { tripNavItems, tripTabItems } from './navConfig'
import { useTrip } from '../features/trips/useTrip'

export function AppLayout() {
  const { id } = useParams<{ id: string }>()
  const { data: trip } = useTrip(id)

  const sidebarItems = id ? tripNavItems(id) : []
  const tabItems = id ? tripTabItems(id) : []

  return (
    <div className="flex min-h-screen bg-st-bg">
      <Sidebar tripItems={sidebarItems} tripTitle={trip?.title} />

      <div className="flex min-w-0 flex-1 flex-col">
        <OfflineWarning />
        <header className="flex items-center gap-2 border-b border-st-line bg-st-surface px-4 py-3 md:hidden">
          <Link to="/" className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-st-md bg-st-primary text-white">
              <Compass className="h-4.5 w-4.5" />
            </span>
            <span className="font-display text-base font-semibold">
              {trip?.title ?? 'Smart Travel'}
            </span>
          </Link>
        </header>

        <main className="flex-1 px-4 pb-24 pt-4 md:px-8 md:pb-8 md:pt-6">
          <Outlet />
        </main>
      </div>

      <TabBar items={tabItems} />
    </div>
  )
}
